import Splide from '@splidejs/splide';
import SmartPhoto from 'smartphoto';

(function() {
  const hamburger = document.querySelector('.hamburger');
  const nav = document.querySelector('.main-navigation');
  const mediaQuery = window.matchMedia("(max-width: 1119px)");
  const parentLinks = document.querySelectorAll('.primary__link--depth-0.primary__link--with-children');

  const initSmartphoto = () => {
    const imageLinks = document.querySelectorAll('a[href$=".gif"], a[href$=".png"], a[href$=".jpg"], a[href$=".jpeg"]');

    if (! imageLinks.length) {
      return;
    }

    [].forEach.call(imageLinks, imageLink => {
      imageLink.classList.add('js-smartphoto');
    });

    new SmartPhoto('.js-smartphoto');
  };

  initSmartphoto();

  const initSplide = () => {
    const splides = document.querySelectorAll('.splide');

    splides.forEach(splide => {
      new Splide(splide, {
        arrows: true,
        autoplay: true,
        interval: 6000,
        type: 'loop',
        pagination: false,
      }).mount();
    });
  };

  initSplide();

  let menuOpen = false;

  hamburger.addEventListener('click', event => {
    event.preventDefault();

    menuOpen = ! menuOpen;

    if (menuOpen) {
      document.body.classList.add('menu-open');
    }
    else {
      document.body.classList.remove('menu-open');
    }
  });

  const hideOnClickOutside = element => {
    const outsideClickListener = event => {
      if (! element.contains(event.target)) {
        element.nextSibling.nextSibling.classList.remove('open');
      }
    }

    document.addEventListener('click', outsideClickListener)
  };

  const menuClickHandler = event => {
    event.preventDefault();

    event.target.nextSibling.nextSibling.classList.toggle('open');
  };

  const mobileMenuClickHandler = event => {
    event.preventDefault();

    const menu = event.target.nextSibling.nextSibling;

    if (menu.style.maxHeight == 0 || menu.style.maxHeight == '0px') {
      menu.style.maxHeight = menu.scrollHeight + 'px';
    }
    else {
      menu.style.maxHeight = 0;
    }
  };

  const mobileHeader = () => {
    [].forEach.call(parentLinks, link => {
      link.removeEventListener('click', menuClickHandler);
      link.addEventListener('click', mobileMenuClickHandler);
    });
  };

  const noMobileHeader = () => {
    [].forEach.call(parentLinks, link => {
      link.addEventListener('click', menuClickHandler);
      link.removeEventListener('click', mobileMenuClickHandler);
      hideOnClickOutside(link);
    });
  };

  const checkMobile = (mediaQuery) => {
    if (mediaQuery.matches) {
      mobileHeader();
    }
    else {
      noMobileHeader();
    }
  };

  checkMobile(mediaQuery);
  mediaQuery.addEventListener('change', checkMobile);

})();
